import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";
import { BASE_URL } from "./common/const";

export const GetRefOBGyExaminationOvaryDescriptionDetail = (params: any) =>
    GET_ENC(`${BASE_URL}/api/RefOBGyExaminationOvaryDescription/GetDetail?` + params, null);

export const GetRefOBGyExaminationOvaryDescriptionList = (params: any) =>
    GET_ENC(`${BASE_URL}/api/RefOBGyExaminationOvaryDescription/GetList?` + params, null);

export const CreateRefOBGyExaminationOvaryDescription = (data: any) =>
    POST_ENC(`${BASE_URL}/api/RefOBGyExaminationOvaryDescription/Create`, data);

export const UpdateRefOBGyExaminationOvaryDescription = (data: any) =>
    POST_ENC(`${BASE_URL}/api/RefOBGyExaminationOvaryDescription/Update`, data);

export const DeleteRefOBGyExaminationOvaryDescription = (data: any) =>
    POST_ENC(`${BASE_URL}/api/RefOBGyExaminationOvaryDescription/Delete`, data);